import React from 'react'
import { Link } from 'react-router-dom'
import { useGetTaxpayerByIdQuery } from './taxpayersApiSlice'

const FieldItem = ({ label, value }) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
        {label}
      </div>
      <div className="text-sm text-slate-800">
        {value !== null && value !== undefined && value !== ''
          ? value
          : '-'}
      </div>
    </div>
  )
}

const TaxPayerDetailForm = ({ taxpayerId }) => {
  const {
    data: taxpayer,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetTaxpayerByIdQuery(taxpayerId)

  if (isLoading) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-5 text-sm text-slate-600 shadow-sm">
        Loading taxpayer detail...
      </div>
    )
  }

  if (isError) {
    return (
      <div className="rounded-2xl border border-red-200 bg-red-50 p-5 text-sm text-red-700 shadow-sm">
        {error?.data?.message || error?.error || 'Failed to load taxpayer detail.'}
      </div>
    )
  }

  if (!isSuccess || !taxpayer) return null

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h2 className="text-lg font-semibold text-slate-800">
              {taxpayer.full_name || 'Taxpayer Detail'}
            </h2>
            <p className="text-sm text-slate-500">
              Read-only taxpayer information
            </p>
          </div>

          <div className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-700">
            Taxpayer ID: {taxpayer.taxpayer_id ?? taxpayer.id ?? '-'}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <FieldItem
            label="Taxpayer ID"
            value={taxpayer.taxpayer_id ?? taxpayer.id}
          />
          <FieldItem
            label="Customer ID"
            value={taxpayer.customer_id}
          />
          <FieldItem
            label="Full Name"
            value={taxpayer.full_name}
          />
          <FieldItem
            label="Nick Name"
            value={taxpayer.nick_name}
          />
          <FieldItem
            label="NPWP"
            value={taxpayer.npwp}
          />
          <FieldItem
            label="NIK"
            value={taxpayer.nik}
          />
          <FieldItem
            label="Passport No"
            value={taxpayer.passport_no}
          />
          <FieldItem
            label="Place of Birth"
            value={taxpayer.place_of_birth}
          />
          <FieldItem
            label="Date of Birth"
            value={taxpayer.date_of_birth}
          />
          <FieldItem
            label="Gender"
            value={taxpayer.gender}
          />
          <FieldItem
            label="Nationality"
            value={taxpayer.nationality}
          />
          <FieldItem
            label="Phone Number"
            value={taxpayer.phone_number}
          />
          <FieldItem
            label="Email"
            value={taxpayer.email}
          />
          <FieldItem
            label="Address Line 1"
            value={taxpayer.address_line1}
          />
          <FieldItem
            label="Address Line 2"
            value={taxpayer.address_line2}
          />
          <FieldItem
            label="City"
            value={taxpayer.city}
          />
          <FieldItem
            label="Province"
            value={taxpayer.province}
          />
          <FieldItem
            label="Postal Code"
            value={taxpayer.postal_code}
          />
          <FieldItem
            label="Country"
            value={taxpayer.country}
          />
          <FieldItem
            label="Created At"
            value={taxpayer.created_at}
          />
          <FieldItem
            label="Updated At"
            value={taxpayer.updated_at}
          />
        </div>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-wrap items-center gap-3">
          <Link
            to="/dash/taxpayers"
            className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
          >
            Back to List
          </Link>

          <Link
            to={`/dash/taxpayers/edit/${taxpayerId}`}
            className="inline-flex items-center justify-center rounded-xl bg-slate-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
          >
            Edit
          </Link>
        </div>
      </div>
    </div>
  )
}

export default TaxPayerDetailForm